import { gql } from '@apollo/client';
import { BAG_TAG_FIELDS, BagType } from '../types/BagTagType';

/**
 * PC 包牌列表/详情页更换容器类型。
 * 后端校验：关包及之后状态禁改；换容器后重量超限则失败（返回 errorCode + errorMessage）。
 */
export const UPDATE_BAG_CONTAINER = gql`
    mutation UpdateBagContainer($bagId: Long!, $bagContainerId: Long) {
        updateBagContainer(bagId: $bagId, bagContainerId: $bagContainerId) {
            success
            errorMessage
            errorCode
            bag {
                ...BagTagFields
            }
        }
    }
    ${BAG_TAG_FIELDS}
`;

export interface UpdateBagContainerResponse {
    updateBagContainer: {
        success: boolean;
        errorMessage?: string | null;
        errorCode?: string | null;
        bag?: BagType | null;
    };
}

export interface UpdateBagContainerInput {
    bagId: number;
    bagContainerId?: number | null;
}
